import { useState } from 'react'
import { PaymentPageEnums } from 'views/Payment/Menu'
import { extractPaymentTokenKey, formatPaymentTokenKey } from '../../hooks/useTokens'

export const useStoredSearchToken = (from: PaymentPageEnums) => {
  const [tokens, setSelectedTokenStored] = useState<string[]>(() => {
    const stored = localStorage.getItem(`${from}-selectedTokenStored`)
    const listTokenStored: string[] = stored ? JSON.parse(stored) : []
    return listTokenStored || []
  })

  const save = (keys: string[]) => {
    const _limit = keys.splice(0, 5)
    localStorage.setItem(`${from}-selectedTokenStored`, JSON.stringify(_limit))
    setSelectedTokenStored(_limit)
  }

  const clear = () => {
    localStorage.removeItem(`${from}-selectedTokenStored`)
    setSelectedTokenStored([])
  }

  const record = (currencyCode: string, currencyAddress: string, currencyNetwork: number, notAcceptNetwork = false) => {
    const key = formatPaymentTokenKey(currencyCode, currencyAddress, currencyNetwork)

    setTimeout(() => {
      save([
        key,
        ...tokens.filter(
          (t) =>
            !(
              extractPaymentTokenKey(t)?.tokenCode === currencyCode &&
              (notAcceptNetwork ? true : extractPaymentTokenKey(t)?.network === currencyNetwork)
            ),
        ),
      ])
    }, 500)
  }

  const remove = (key: string) => {
    save(tokens.filter((item) => item !== key))
  }

  return {
    record,
    remove,
    clear,
    tokens,
  }
}

export type IStoredSearchToken = ReturnType<typeof useStoredSearchToken>
